import { z } from 'zod/v4'

export const colorSchema = z
  .string()
  .trim()
  .regex(/^#?[0-9a-f]{6}$/i, 'Invalid color')
